<template>
  <div
      class="container is-fullheight"
      style="padding: 2rem; background-color: #f2f2f2"
  >
    <div
        class="section"
        style="background-color: white; height: 100%"
        ref="exceptionalRequest"
    >
      <b-loading
          :is-full-page="true"
          v-model="isLoading"
          :can-cancel="false"
      ></b-loading>
      <!-- Titulo de la sección -->
      <div>
        <div class="columns">
          <div class="column">
            <h1 class="subtitle is-1 has-text-secondary">
              Iniciar Solicitud Excepcional - MSD
            </h1>
          </div>
        </div>

        <div v-if="!start_request" class="columns is-centered">
          <div class="column is-11">
            <div class="is-border-black mt-4">
              <div class="m-5">
                <div class="title is-4 mt-2">Información de este proceso</div>
                <p style="font-size: 1.2em">
                  Este formulario está destinado a la <b>creación de solicitudes de forma excepcional</b>, en casos en los que
                  el estudiante <b>no puede ingresar al sistema por sus propios medios</b> debido a situaciones especiales
                  (Algún tipo de inhabilitación). <br>
                  La solicitud será gestionada <b>por personal autorizado del sistema</b>, quien deberá proporcionar:
                </p>
                <div class="notification is-light">
                  <div class="box has-background-light p-3 mb-2">
                    <span class="icon has-text-info mr-2"><i class="fas fa-info-circle"></i></span>
                    <b>Datos de contacto del responsable</b> que recibirá las notificaciones del proceso.
                  </div>
                  <div class="box has-background-light p-3">
                    <span class="icon has-text-info mr-2"><i class="fas fa-info-circle"></i></span>
                    <b>Motivo detallado</b> por el cual la solicitud se realiza a nombre del estudiante.
                  </div>
                </div>
                <p style="font-size: 1.2em">
                  Esta funcionalidad debe utilizarse solo cuando esté debidamente justificada la imposibilidad del estudiante de realizar la solicitud directamente.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!start_request" class="columns is-centered">
          <button
              class="button is-primary mx-1"
              type="submit"
              @click="start_request = true"
          >
            Iniciar
          </button>
        </div>
        <div v-if="start_request">
          <hr class="solid mb-5" />
          <div class="columns">
            <div class="column is-centered">
              <div class="title is-4 mt-2">Búsqueda del estudiante</div>
            </div>
          </div>
          <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(studentsFilter)">
              <div class="columns">
                <div class="column pb-0">
                  <b-field label="Ingrese RUT">
                    <ValidationProvider
                        v-slot="{ errors }"
                        :rules="{

                    regex: /\b\d{1,3}(\.\d{3})*-[0-9kK]\b/,
                  }"
                    >
                      <b-input
                          v-model="formattedRut"
                          type="text"
                          placeholder="Ingrese RUT (ej: 12.345.678-k)"
                      ></b-input>
                      <span class="validation-alert">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>
                </div>
              </div>
              <div class="level-right buttons">
                <b-button
                    class="is-secondary"
                    icon-left="search"
                    native-type="submit"
                >
                  Buscar
                </b-button>
              </div>
            </form>
          </ValidationObserver>
          <div v-if="student">
            <div class="columns">
              <div class="column is-centered">
                <div class="title is-4 mt-2">Información del estudiante</div>
              </div>
            </div>
            <div
                :class="{
                'card': true,
                'is-border-light-grey': true,
              }"
            >
              <div class="card-content">
                <div class="content">
                  <div class="has-text-centered">
                    <div class="my-1"><b>Nombre completo:</b> {{ student.fullname }}</div>
                    <div class="my-1"><b>RUT:</b> {{ student.rut }}</div>
                    <div class="my-1"><b>Correo SIAC:</b> {{ student.email }}</div>
                    <div class="my-1"><b>Carreras cursadas:</b></div>
                    <div v-for="career in student.careers" class="my-1">
                      {{ formatCareerName(career) }}
                      <b-icon
                          v-if="career.jornada === 'Diurno'"
                          class="mr-1"
                          icon="sun"
                      ></b-icon>
                      <b-icon
                          v-else-if="career.jornada === 'Vespertino'"
                          class="mr-1"
                          icon="moon"
                      ></b-icon>
                      <b-icon v-else class="mr-1" icon="question"></b-icon>
                      Ingreso {{ career.semestre_ingreso }}-{{ career.agno_ingreso }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <br>
          <div v-if="student">
            <div class="columns">
              <div class="column is-centered">
                <div class="title is-4 mt-2">Datos del responsable</div>
              </div>
            </div>
            <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(getStudentUser)">
                <div class="columns">
                  <div class="column">
                    <b-field label="Nombres*">
                      <ValidationProvider rules="required" v-slot="{errors}">
                        <b-input
                            v-model="responsable_nombres"
                            placeholder="Ej: Juan Luis">
                        </b-input>
                        <span class="validation-alert">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="Primer Apellido*">
                      <ValidationProvider rules="required" v-slot="{errors}">
                        <b-input
                            v-model="responsable_primer_apellido"
                            placeholder="Ej: Perez">
                        </b-input>
                        <span class="validation-alert">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="Segundo Apellido">
                      <b-input
                          v-model="responsable_segundo_apellido"
                          placeholder="Ej: Gonzalez">
                      </b-input>
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <b-field label="Email*">
                      <ValidationProvider rules="required" v-slot="{errors}">
                        <b-input
                            v-model="responsable_email"
                            placeholder="Ej: correo@electronico.cl"
                            type="email">
                        </b-input>
                        <span class="validation-alert">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="Teléfono*">
                      <ValidationProvider rules="required" v-slot="{errors}">
                        <b-input
                            v-model="responsable_telefono"
                            placeholder="Ej: +56912345678">
                        </b-input>
                        <span class="validation-alert">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                </div>
                <br>
                <div class="columns">
                  <div class="column is-centered">
                    <div class="title is-4 mt-2">Datos de la solicitud</div>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <b-field label="Seleccione Solicitud*">
                      <ValidationProvider rules="required" v-slot="{errors}">
                        <multiselect
                            v-model="selected_request_type"
                            :options="request_types"
                            :custom-label="(opt) => request_types.find((x) => x.id === opt.id).real_name"
                            :multiple="false"
                            :allow-empty="false"
                            placeholder="Seleccione una solicitud"
                            selectLabel="Presione para seleccionar"
                            selectedLabel="Seleccionado"
                        >
                          <template v-slot:noOptions> No existen datos</template>
                          <span slot="noResult"> No se encontraron elementos. </span>
                        </multiselect>
                        <span class="validation-alert">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <b-field label="Motivo de la excepción*">
                      <ValidationProvider rules="required" v-slot="{errors}">
                        <b-input
                            v-model="motivo"
                            placeholder=""
                            type="textarea">
                        </b-input>
                        <span class="validation-alert">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                </div>
                <div class="columns is-centered">
                  <button
                      class="button is-primary mx-1"
                      native-type="submit"
                  >
                    Iniciar Solicitud
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import axios from "axios";
import StudentListCards from "../Students/StudentListCards.vue";

export default {
  name: "ExceptionalRequest",
  props: ["request_types"],
  components: {StudentListCards},

  data() {
    return {
      start_request: false,
      isLoading: false,
      student: null,
      rut: "",
      responsable_nombres:"",
      responsable_primer_apellido:"",
      responsable_segundo_apellido:"",
      responsable_email:"",
      responsable_telefono:"",
      motivo:"",
      tipo_solicitud:"",
      selected_request_type:null,
      student_user:null
    }
  },
  methods:{
    studentsFilter() {
      this.isLoading = true;
      this.student = null;
      axios
          .get(`/people/students/filter.json`, {
            params: {
              rut: this.rut.slice(0, -1),
              name: null,
              lastname: null,
              surname: null,
              email: null,
            },
          })
          .then((response) => {
            if(response.data.students.length > 1){
              this.$buefy.dialog.alert({
                title: "Advertencia",
                message: "Se encontraron múltiples estudiantes con el mismo RUT.",
                hasIcon: true,
                type: "is-warning",
                confirmText: "Entendido",
                onConfirm: () => {
                  // Asignamos el primer estudiante encontrado
                  this.student = response.data.students[0];
                }
              });
            } else if(response.data.students.length === 1){
              this.student = response.data.students[0];
            } else {
              this.$buefy.dialog.alert({
                title: "Información",
                message: "No se encontraron estudiantes con los criterios de búsqueda.",
                hasIcon: true,
                type: "is-info",
                confirmText: "Aceptar",
              });
            }


          })
          .catch((error) => {
            console.error(error);
            if (error.response.data.status === 404) {
              this.$buefy.dialog.alert({
                title: "Atención",
                message:
                    "No se encontraron estudiantes con la información ingresada.",
                hasIcon: true,
                type: "is-warning",
                confirmText: "Ok",
              });
            } else {
              this.$buefy.dialog.alert({
                title: "Error",
                message: "Error al realizar la búsqueda, por favor reintente.",
                hasIcon: true,
                type: "is-danger",
                confirmText: "Ok",
              });
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    formatCareerName(career) {
      let jornada = career.jornada;
      if (career.jornada === "" || career.jornada == null || career.jornada == undefined) jornada = "Jornada indefinida";
      return `[${career.codigo}] ${career.nombre_carrera} - ${career.tipo}, ${jornada} `;
    },
    getStudentUser(){
      this.isLoading = true;
      axios.
          post("/requests/find_or_create_student.json", {rut: this.student.rut, correo: this.student.email}).
      then((response) => {
        this.student_user = response.data.user_id;
        this.initRequest()
      }).
      catch((error) => {
        console.error(error);
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Error al procesar los datos del estudiante.",
          hasIcon: true,
          type: "is-danger",
          confirmText: "Ok",
        });
      }).
      finally(() => {
        this.isLoading = false;
      });
    },
    initRequest(){
      // Preparar los datos del responsable y motivo
      const params = new URLSearchParams({
        request_type_id: this.selected_request_type.id,
        student_user_id: this.student_user,
        responsable_nombres: this.responsable_nombres,
        responsable_primer_apellido: this.responsable_primer_apellido,
        responsable_segundo_apellido: this.responsable_segundo_apellido,
        responsable_email: this.responsable_email,
        responsable_telefono: this.responsable_telefono,
        motivo: this.motivo,
        type: 'exceptional'
      });

      window.location.href = `/requests/new_exceptional_request?${params.toString()}`;

    },
  },
  computed:{
    formattedRut: {
      get() {
        if (this.rut.length > 1) {
          let cleanedRut = this.rut.replace(/[^0-9kK]/g, "");
          let rutBody = cleanedRut.slice(0, -1);
          let dv = cleanedRut.slice(-1).toUpperCase();
          return rutBody.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "-" + dv;
        }
      },
      set(value) {
        this.rut = value.replace(/[^0-9kK]/g, "").toUpperCase();
      },
    },
  }
}

</script>

<style scoped>

</style>